import { FormEvent } from 'react';
import { UseFormReturnType } from '@mantine/form';
import { Stack, TextInput } from '@mantine/core';
import { OnboardingSignupFormValues } from '../applySubmissionError';
import { WizardShell } from '../components/WizardShell';

type FirstNameStepProps = {
  form: UseFormReturnType<OnboardingSignupFormValues>;
  direction: 1 | -1;
  currentStepIndex: number;
  totalSteps: number;
  onNext: () => void;
};

export function FirstNameStep({ form, onNext }: FirstNameStepProps) {
  const handleNext = (event?: FormEvent) => {
    event?.preventDefault();
    if (form.validateField('firstName').hasError || form.validateField('lastName').hasError) return;
    onNext();
  };

  const isValid = form.isValid('firstName') && form.isValid('lastName');

  return (
    <WizardShell title="What's your name?" onAction={handleNext} actionDisabled={!isValid}>
      <form onSubmit={handleNext}>
        <Stack gap="lg">
          <TextInput
            required
            label="First name"
            placeholder="e.g. Jane"
            key={form.key('firstName')}
            {...form.getInputProps('firstName')}
            data-autofocus
          />
          <TextInput
            required
            label="Last name"
            placeholder="e.g. Doe"
            key={form.key('lastName')}
            {...form.getInputProps('lastName')}
          />
        </Stack>
      </form>
    </WizardShell>
  );
}
